class WindowFocusManager {
    public callbacks: Array<(focused: boolean) => void> = [];

    private hiddenVar: any;

    constructor() {
        if (document.hasOwnProperty("webkitHidden")) {
            this.hiddenVar = "webkitvisibilitychange";
        } else if (document.hasOwnProperty("mozHidden")) {
            this.hiddenVar = "mozvisibilitychange";
        } else if (document.hasOwnProperty("msHidden")) {
            this.hiddenVar = "msvisibilitychange";
        } else if (document.hasOwnProperty("hidden")) {
            this.hiddenVar = "visibilitychange";
        } else {
            this.hiddenVar = null;
        }

        const onChange = (event: any) => {
            for (const callback of this.callbacks) {
                callback(event.type === "focus");
            }
        };

        //  Does browser support it? If not (like in IE9 or old Android) we need to fall back to blur/focus
        if (this.hiddenVar) {
            document.addEventListener(this.hiddenVar, onChange, false);
        }

        window.onblur = onChange;
        window.onfocus = onChange;

        window.onpagehide = onChange;
        window.onpageshow = onChange;
    }
}

const windowFocusManager = new WindowFocusManager();

/**
 * Detects when the browser window has lost or gained focus and calls the callback with this information
 *
 * @param callback {(visible:boolean) => void}
 */
export function AddWindowFocusChangeLsitener(callback: (focused: boolean) => void) {
    windowFocusManager.callbacks.push(callback);
}

export function RemoveWindowFocusChangeLsitener(callback: (focused: boolean) => void) {
    while (windowFocusManager.callbacks.indexOf(callback) > -1) {
        windowFocusManager.callbacks.splice(windowFocusManager.callbacks.indexOf(callback), 1);
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/utils/browser-utils.ts